export function getContrastColor(hexColor) {
  // Convert the hex color to RGB
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  // Calculate the relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Use white text for dark backgrounds and black text for light backgrounds
  return luminance > 0.5 ? "#000000" : "#FFFFFF";
}
export const countWords = (text) => {
  // Use regex to split the text into words
  const words = text.trim().split(/\s+/);
  // Filter out symbols and count only words containing letters and/or digits
  const validWords = words.filter((word) => word.match(/[A-Za-z0-9]/));
  return validWords.length;
};
// Create a function to sanitize and clean text content
export const cleanTextContent = (textContent) => {
  // Replace non-breaking spaces (&nbsp;) with regular spaces
  const cleanedHtmlContent = textContent.replace(/&nbsp;/g, " ");

  // Strip HTML tags to extract text content
  const cleanedTextContent = cleanedHtmlContent.replace(/<\/?[^>]+(>|$)/g, " ");

  return cleanedTextContent;
};
// Helper function to get the category for a word
export const getCategoryForWord = (word, transitionWords) => {
  for (const [category, categoryInfo] of transitionWords.entries()) {
    if (categoryInfo.words.includes(word)) {
      return category;
    }
  }
  return null;
};
export const getCategoryNamesAndColors = (transitionWords) => {
  const categoryNamesAndColors = [];

  for (const [category, { color }] of transitionWords) {
    categoryNamesAndColors.push({ name: category, color });
  }

  return categoryNamesAndColors;
};
